import React from "react";
import { Card, CardBody, Col } from "reactstrap";

interface Props {
  resumen: any;
  loading: boolean;
}

export const ReporteAsesorResumen = ({ resumen, loading }: Props) => {
  const porcentajeColor = (porcentaje: number) => {
    if (porcentaje >= 100) return "success";
    if (porcentaje >= 75) return "warning";
    return "danger";
  };

  if (!resumen) {
    return null;
  }

  const operaciones =
    (resumen.cantidadVentas || 0) +
    (resumen.cantidadReactivaciones || 0) +
    (resumen.cantidadIntegrantes || 0);

  const descontadas = resumen.cantidadDescontada || 0;
  const total = resumen.puntosAlcanceTotal || 0;
  const meta = resumen.metaConsolidada || 0;
  const porcentaje = resumen.porcentajeAlcance
    ? parseFloat(resumen.porcentajeAlcance)
    : 0;
  const alcancesConfirmados = resumen.alcancesConfirmados || false;

  return (
    <div className="row mb-4 mt-4" style={{ opacity: loading ? 0.5 : 1 }}>
      {!alcancesConfirmados && (
        <Col md={12}>
          <div
            className="alert alert-info mb-3"
            role="alert"
            style={{ fontSize: "14px" }}
          >
            <strong>Datos preliminares:</strong> Los alcances aún no han sido
            confirmados. Los datos mostrados se calculan en tiempo real y pueden
            cambiar.
          </div>
        </Col>
      )}
      <Col md={3}>
        <Card className="border-primary">
          <CardBody>
            <h6 className="text-muted mb-2">Operaciones</h6>
            <h4 className="mb-0 text-primary">
              {operaciones > 0 ? operaciones : 0}
            </h4>
            <small className="text-muted">
              {resumen.cantidadVentas || 0} Ventas &nbsp;&nbsp;
              {resumen.cantidadReactivaciones || 0} Reactiv. &nbsp;&nbsp;
              {resumen.cantidadIntegrantes || 0} Integ.
            </small>
          </CardBody>
        </Card>
      </Col>
      <Col md={3}>
        <Card className={descontadas > 0 ? "border-warning" : "border-info"}>
          <CardBody>
            <h6 className="text-muted mb-2">Membresías descontadas</h6>
            <h4
              className={`mb-0 ${
                descontadas > 0 ? "text-warning" : "text-info"
              }`}
            >
              {descontadas > 0 ? `-${descontadas}` : 0}
            </h4>
            <small className="text-muted">
              {descontadas > 0
                ? "Por documentación pendiente"
                : "Sin descuentos"}
            </small>
          </CardBody>
        </Card>
      </Col>
      <Col md={3}>
        <Card className="border-secondary">
          <CardBody>
            <h6 className="text-muted mb-2">Alcance total</h6>
            <h4 className="mb-0 text-secondary">{total > 0 ? total : 0}</h4>
            <small className="text-muted">
              {meta > 0 ? `Meta: ${meta}` : "Sin meta configurada"}
            </small>
          </CardBody>
        </Card>
      </Col>
      <Col md={3}>
        <Card className={`border-${porcentajeColor(porcentaje)}`}>
          <CardBody>
            <h6 className="text-muted mb-2">Porcentaje de alcance</h6>
            <h4 className={`mb-0 text-${porcentajeColor(porcentaje)}`}>
              {porcentaje > 0 ? `${porcentaje.toFixed(2)}%` : "0%"}
            </h4>
            <small className="text-muted">Respecto a la meta</small>
          </CardBody>
        </Card>
      </Col>
      <Col>
        <hr />
      </Col>
    </div>
  );
};
